import { render, staticRenderFns } from "./shop-cart.vue?vue&type=template&id=28927425&scoped=true"
import script from "./shop-cart.vue?vue&type=script&lang=js"
export * from "./shop-cart.vue?vue&type=script&lang=js"
import style0 from "./shop-cart.vue?vue&type=style&index=0&id=28927425&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28927425",
  null
  
)

export default component.exports